export { default as StarRating } from "./StarRating";
